<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >商务及技术文件详细评审结果</el-button
              >
            </div>
          </div>
          <div>
            <div
              class="irem"
              v-for="(item, index) in exportExcelData"
              :key="index"
            >
              <div class="irems">
                <div style="width: 72px">包件名称：</div>
                <div class="itt">{{ item.packName }}</div>
              </div>
              <div style="width: 300px">
                通过第一信封详细评审的投标人数量：{{ item.bidNum }}
              </div>
            </div>
            <div class="irem star">
              注：若通过商务及技术文件初步评审的分包商数量小于或等于所设置的“通过第一信封详细评审的投标人数量”，则不需要进行商务及技术文件打分，直接进入报价文件评审环节，并且通过商务技术文件详细评审的分包商总数量不得大于通过第一信封详细评审的投标人数量。
            </div>
          </div>
          <el-table
            v-if="subPackageFlag"
            :data="tableData"
            border
            :span-method="objectSpanMethodReport"
          >
            <el-table-column
              v-for="(item, index) in confirmCheckColumns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>
                  <span>{{ item.label }}</span>
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-if="
                    item.type === 'select' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  v-model.trim="scope.row[item.prop]"
                  @change="changeLostFlag(scope.row, scope.$index)"
                >
                  <el-option value="0" label="通过">通过</el-option>
                  <el-option value="1" label="不通过">不通过</el-option>
                </el-select>
                <span v-else-if="item.type === 'select'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <el-input
                  v-else-if="
                    item.type === 'input' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  v-model.trim="scope.row[item.prop]"
                  maxlength="1000"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  placeholder="请输入"
                />
                <el-button
                  v-else-if="item.type === 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                  >查看</el-button
                >
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="tableData" border v-else>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              v-for="(item, index) in confirmCheckColumns2"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>
                  <span>{{ item.label }}</span>
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-if="
                    item.type === 'select' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  v-model.trim="scope.row[item.prop]"
                  @change="changeLostFlag(scope.row, scope.$index)"
                >
                  <el-option value="0" label="通过">通过</el-option>
                  <el-option value="1" label="不通过">不通过</el-option>
                </el-select>
                <span v-else-if="item.type === 'select'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <el-input
                  v-else-if="
                    item.type === 'input' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  v-model.trim="scope.row[item.prop]"
                  maxlength="1000"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  placeholder="请输入"
                />
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                >
                  查看
                </el-button>
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!--      确认中-->
          <template v-if="exeStatus !== '0'">
            <div class="ccui-tab-iframe">
              <div class="ccui-tab-wrapper">
                <el-button type="table-top-active" size="mini"
                  >专家确认列表</el-button
                >
              </div>
            </div>
            <el-table
              :data="expertConfirmtableData"
              border
              :span-method="objectSpanMethodResult"
            >
              <el-table-column
                v-for="(item, index) in expertColumns"
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
              ></el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div class="operate">
        <!--      组长按钮-->
        <template>
          <template v-if="expertRole === '1'">
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('1')"
              v-if="exeStatus === '0' || (exeStatus === '2' && isEdit)"
              >保存</el-button
            >
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-edit"
              v-if="exeStatus === '2' && !isEdit"
              @click="edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('2')"
              v-if="billStatus !== '1'"
              >提交确认</el-button
            >
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-agree"
              @click="refCheckEffect"
              v-if="exeStatus === '2' && !isEdit"
              >生效</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-sharing-o"
              @click="init"
              v-if="isEdit"
              >取消</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-sharing-o"
              @click="init"
              v-if="!isEdit"
              >刷新</el-button
            >
          </template>
        </template>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        title="商务及技术信息详情"
        width="1200px"
        v-if="dialogVisible"
      >
        <supplierBidDetails
          :supQuoteId="formData.supQuoteId"
          :supPackQuoteId="formData.supPackQuoteId"
          :supCode="formData.supCode"
          :packId="formData.packId"
        ></supplierBidDetails>
        <div slot="footer"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetailsNew.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQrySupComCheckListApi,
  scpDealSupComCheckSaveApi,
  scpQrySupComCheckConfirmListApi,
  scpQueryPurchaseSchemeDetailApi,
  scpDealSupComCheckEffectApi,
  checkSubconControlAndBlack,
  scpQryBidEvaProcessStatusApi,
  scpListPurchaseSchemePackageApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";

export default {
  name: "businessBidDetailEdit",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  /**
   * billStatus   exeStatus(操作)       按钮
   0检查中  0未检查（第一次）		保存  提交确认 刷新
   0检查中  2检查中（保存）		    编辑  提交确认 生效  刷新
   2确认中	2检查中（提交确认）	    编辑  提交确认 生效  刷新
   1检查完成	1检查完成（生效）		刷新
   **/
  data() {
    return {
      BigNumber: BigNumber,
      purchaseUnitId: "",
      evaMethod: "",
      breadcrumbData: {
        titname: "详细评审编制",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "editorial"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "2"
          ? "confirmation"
          : "checkCompleted", // 确认中（2）：confirmation 检查中（0）：editorial 检查完成（1）：
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      exeStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .exeStatus,
      tableData: [],
      expertConfirmtableData: [],
      dialogVisible: false,
      supComCheckConfirm: {
        confirmOpinion: ""
      },
      expertRole: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .expertRole, // 专家角色 : 1-组长 0-组员
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件id
      },
      confirmCheckColumns: [
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "packName",
          label: "包件名称",
          minWidth: 150
        },
        // {
        //   prop: "bidNum",
        //   label: "通过第一信封详细评审的投标人数量",
        //   width: 110,
        // },
        {
          prop: "supName",
          label: "分包商",
          minWidth: 280
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        // {
        //   prop: "priceAmount",
        //   label: "含税金额",
        //   width: 180,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "noTaxPriceAmount",
        //   label: "不含税金额",
        //   width: 200,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "taxAmountCount",
        //   label: "税额",
        //   width: 180,
        //   align: "right",
        //   money: true
        // },
        {
          prop: "supCode",
          label: "商务及技术信息",
          type: "link",
          width: 150
        },
        {
          prop: "sumScore",
          label: "汇总得分",
          width: 100
        },
        {
          prop: "passFlag",
          label: "是否通过",
          width: 100,
          type: "select"
        },
        {
          prop: "reason",
          label: "详细评审意见",
          type: "input",
          "min-width": 200,
          required: true
        }
      ],
      confirmCheckColumns2: [
        // {
        //   prop: "bidNum",
        //   label: "通过第一信封详细评审的投标人数量",
        //   width: 110,
        // },
        {
          prop: "supName",
          label: "分包商",
          minWidth: 280
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        // {
        //   prop: "priceAmount",
        //   label: "含税金额",
        //   width: 150,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "noTaxPriceAmount",
        //   label: "不含税金额",
        //   width: 200,
        //   align: "right",
        //   money: true
        // },
        // {
        //   prop: "taxAmountCount",
        //   label: "税额",
        //   width: 150,
        //   align: "right",
        //   money: true
        // },
        {
          prop: "supCode",
          label: "商务及技术信息",
          type: "link",
          width: 150
        },
        {
          prop: "sumScore",
          label: "汇总得分",
          width: 100
        },
        {
          prop: "passFlag",
          label: "是否通过",
          width: 100,
          type: "select"
        },
        {
          prop: "reason",
          label: "详细评审意见",
          type: "input",
          "min-width": 200,
          required: true
        }
      ],
      expertColumns: [
        {
          prop: "round",
          label: "确认轮数",
          width: 80
        },
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "confirmUserName",
          label: "专家姓名",
          width: 120
        },
        {
          prop: "confirmResultStr",
          label: "确认结果",
          width: 120
        },
        {
          prop: "confirmOpinion",
          label: "确认意见"
        },
        {
          prop: "confirmTime",
          label: "确认日期",
          width: 170
        },
        {
          prop: "confirmStatusStr",
          label: "确认状态",
          width: 80
        }
      ],
      exportExcelData: [],
      labelShow: false,
      subPackageFlag: false, //true分包，false不分包
      purchaseType: "",
      isEdit: false
    };
  },
  created() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
  },
  mounted() {
    this.getData();
    this.getPutId();
    this.getPackageFlag();
    this.labelShow = true;
  },
  watch: {
    purchaseType: {
      handler(newVal) {
        if (
          newVal == "1" ||
          newVal == "2" ||
          newVal == "4" ||
          newVal == "7" ||
          newVal == "8"
        ) {
          let bidEvaProcessStatus = JSON.parse(
            sessionStorage.getItem("bidEvaProcessStatus")
          );
          switch (bidEvaProcessStatus.billStatus) {
            case "0":
              this.breadcrumbData.status = "评审中";
              break;
            case "1":
              this.breadcrumbData.status = "评审完成";
              break;
            case "2":
              this.breadcrumbData.status = "评审确认中";
              break;
            default:
              break;
          }
          this.confirmCheckColumns.forEach(item => {
            if (item.prop == "supCode") {
              item.label = "响应文件";
            }
          });
          this.confirmCheckColumns2.forEach(item => {
            if (item.prop == "supCode") {
              item.label = "响应文件";
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    getPutId() {
      scpQueryPurchaseSchemeDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.purchaseUnitId = res.data.data.purchaseUnitId;
        this.evaMethod = res.data.data.evaMethod;
      });
    },
    getPackageFlag() {
      let expertSourceData = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      );

      if (
        expertSourceData.purchaseType == "50" ||
        expertSourceData.purchaseType == "53"
      ) {
        this.confirmCheckColumns.splice(3, 1);
        this.confirmCheckColumns2.splice(1, 1);
      }
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    init() {
      let joinId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId;
      if (
        this.$router.history.current.query.evaPurStep === "801" ||
        this.$router.history.current.query.evaPurStep === "802"
      ) {
        joinId = sessionStorage.getItem("joinId");
      }
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: joinId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        this.$set(this, "labelShow", false);
        this.billStatus = res.data.data.billStatus;
        this.$set(
          this,
          "labelType",
          res.data.data.billStatus === "0"
            ? "editorial"
            : res.data.data.billStatus === "2"
            ? "confirmation"
            : "checkCompleted"
        );
        // this.labelType =
        //   this.billStatus === "0"
        //     ? "editorial"
        //     : this.billStatus === "2"
        //     ? "confirmation"
        //     : "checkCompleted";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        console.log(res.data.data, "res.data.data");
        this.isEdit = false;
        let bidEvaProcessStatus = JSON.parse(
          sessionStorage.getItem("bidEvaProcessStatus")
        );
        if (
          this.purchaseType == "1" ||
          this.purchaseType == "4" ||
          this.purchaseType == "7" ||
          this.purchaseType == "8"
        ) {
          let bidEvaProcessStatus = JSON.parse(
            sessionStorage.getItem("bidEvaProcessStatus")
          );
          switch (bidEvaProcessStatus.billStatus) {
            case "0":
              this.breadcrumbData.status = "评审中";
              break;
            case "1":
              this.breadcrumbData.status = "评审完成";
              break;
            case "2":
              this.breadcrumbData.status = "评审确认中";
              break;
            default:
              break;
          }
        }
        this.$set(
          this.breadcrumbData,
          "status",
          bidEvaProcessStatus.billStatusName
        );
        this.$set(this, "labelShow", true);
        this.getData();
        this.reload();
      });
    },
    edit() {
      this.isEdit = true;
    },
    getData() {
      // 分包商详细评审结果列表
      scpQrySupComCheckListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        systemFlag: 0,
        joinExpertId: sessionStorage.getItem("joinId"),
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        if (res.data.code === "0") {
          this.exportExcelData = res.data.data.rows;
          let data = [];
          let devspan = 0;
          // 通过包件id进行排序
          res.data.data.rows.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            res.data.data.rows.forEach((item, index) => {
              if (item.packId == 0) {
                this.confirmCheckColumns.splice(1, 1);
              }
              if (index > 0) {
                devspan +=
                  res.data.data.rows[index - 1].sscSupComPriceBOS.length;
              }
              if (item.sscSupComPriceBOS && item.sscSupComPriceBOS.length > 0) {
                item.sscSupComPriceBOS.forEach((itemtow, indextow) => {
                  let obj = {
                    id: index + 1,
                    packName:
                      item.packStatus == "5" || item.packStatus == "2"
                        ? item.packName + "(已流标)"
                        : item.packName, // 是否流标packStatus 1正常2流标（评标前流标）5流标（评标后流标）
                    bidNum: item.bidNum,
                    packId: item.packId,
                    supCode: itemtow.supCode,
                    subconCode: itemtow.subconCode,
                    supName: itemtow.supName,
                    supQuoteId: itemtow.supQuoteId,
                    priceAmount: itemtow.priceAmount,
                    noTaxPriceAmount: itemtow.noTaxPriceAmount,
                    taxAmount: itemtow.taxAmount,
                    taxAmountCount: itemtow.taxAmountCount,
                    industryTypeName: itemtow.industryTypeName,
                    companyTypeName: itemtow.companyTypeName,
                    passFlag: itemtow.passFlag,
                    passFlagStr: itemtow.passFlagStr,
                    supJoinId: itemtow.supJoinId,
                    supPackQuoteId: itemtow.supPackQuoteId,
                    sumScore: itemtow.sumScore,
                    reason: itemtow.reason
                      ? itemtow.reason
                      : itemtow.passFlag === "1"
                      ? "不通过"
                      : "通过",
                    round: itemtow.round,
                    rowspan: item.sscSupComPriceBOS.length,
                    devspan: devspan
                  };
                  data.push(obj);
                });
              }
            });
            this.tableData = data;
          }
        }
      });
      // 专家确认列表
      scpQrySupComCheckConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        // round: 1,
        confirmType: "1",
        pageNo: -1,
        pageSize: -1
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                confirmId: itemtow.confirmId,
                round: itemtow.round,
                schemeId: itemtow.schemeId,
                confirmUserId: itemtow.confirmUserId,
                confirmUserName: itemtow.confirmUserName,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: "",
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              if (itemtow.confirmOpinion == "" && itemtow.confirmResult) {
                if (itemtow.confirmResult == 1) {
                  obj.confirmOpinion = "同意";
                } else {
                  obj.confirmOpinion = "不同意";
                }
              } else {
                obj.confirmOpinion = itemtow.confirmOpinion;
              }
              newData.push(obj);
            });
          });
          this.expertConfirmtableData = newData;
        }
      });
    },
    //详细评审结果
    objectSpanMethodReport({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = row.packId;
      this.dialogVisible = true;
    },
    changeLostFlag(row, index) {
      if (row.passFlag === "1") {
        // 不通过 reason
        row.reason = "不通过";
      } else {
        // 通过
        row.reason = "通过";
      }
    },
    dealSupComCheckSave(type) {
      console.log("符合性编制检查");
      // 详细评审意见不能为空
      let flag = true;
      this.tableData.forEach(item => {
        if (!item.reason) {
          flag = false;
        }
      });
      let packIdArr = [];
      this.tableData.forEach(item => {
        if (packIdArr.every(packItem => packItem.packId !== item.packId)) {
          packIdArr.push(item);
        }
      });
      let sscPackSupComCheckBOS = [];
      packIdArr.forEach(item => {
        let sscPackSupComCheckBO = {};
        let sscSupComPriceBOS = [];
        sscPackSupComCheckBO.packId = item.packId;
        sscPackSupComCheckBO.bidNum = item.bidNum;
        sscPackSupComCheckBO.packName = item.packName;
        this.tableData.forEach(tableItem => {
          if (item.packId === tableItem.packId) {
            let sscSupComPriceBO = {};
            sscSupComPriceBO.supCode = tableItem.supCode;
            sscSupComPriceBO.supName = tableItem.supName;
            sscSupComPriceBO.priceAmount = tableItem.priceAmount;
            sscSupComPriceBO.taxAmount = tableItem.taxAmount;
            sscSupComPriceBO.taxAmountCount = tableItem.taxAmountCount;
            sscSupComPriceBO.noTaxPriceAmount = tableItem.noTaxPriceAmount;
            sscSupComPriceBO.passFlag = tableItem.passFlag;
            sscSupComPriceBO.passFlagStr =
              tableItem.passFlag === "1" ? "不通过" : "通过";
            sscSupComPriceBO.reason = tableItem.reason;
            sscSupComPriceBO.round = tableItem.round;
            sscSupComPriceBO.supJoinId = tableItem.supJoinId;
            sscSupComPriceBO.supQuoteId = tableItem.supQuoteId;
            sscSupComPriceBO.supPackQuoteId = tableItem.supPackQuoteId;
            sscSupComPriceBOS.push(sscSupComPriceBO);
          }
        });
        sscPackSupComCheckBO.sscSupComPriceBOS = sscSupComPriceBOS;
        sscPackSupComCheckBOS.push(sscPackSupComCheckBO);
      });
      console.log("sscPackSupComCheckBOS", sscPackSupComCheckBOS);
      console.log("tableData", this.tableData);
      if (flag) {
        // 通过数量必须小于等于包件设置的最大通过数量
        let str = "";
        for (let i = 0; i < sscPackSupComCheckBOS.length; i++) {
          const item = sscPackSupComCheckBOS[i];
          let num = 0;
          item.sscSupComPriceBOS.forEach(items => {
            if (items.passFlag === "0") {
              num++;
            }
          });
          if (num > item.bidNum) {
            if (sscPackSupComCheckBOS.length === 1) {
              str =
                "通过评审分包商商数量不得高于通过第一信封详细评审的投标人数量！";
            } else {
              str =
                "包件（" +
                item.packName +
                "）通过评审分包商商数量不得高于通过第一信封详细评审的投标人数量！";
            }
            break;
          }
        }
        if (str) {
          this.$message({
            message: str,
            type: "error",
            duration: 5000,
            showClose: true,
            ccuiCustom: true
          });
        } else {
          scpDealSupComCheckSaveApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            operType: type,
            purStep: this.$router.history.current.query.menuKey,
            evaPurStep: this.$router.history.current.query.evaPurStep,
            sscPackSupComCheckBOS: sscPackSupComCheckBOS
          }).then(res => {
            if (res.data.code == "0") {
              this.init();
              this.$message({
                message: type == "1" ? "保存成功" : "提交确认成功",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
            }
          });
        }
      } else {
        this.$message({
          message: "详细评审意见不能为空！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },

    // 生效的前置校验，提示黑名单信息等
    refCheckEffect() {
      let _this = this;
      let ids = [];
      let subconCodes = [];
      _this.tableData.forEach(item => {
        if (item.passFlag === "0") {
          ids.push(item.supCode);
          subconCodes.push(item.subconCode);
        }
      });
      let params = {
        subconInfoIds: ids,
        checkTypes: [1, 2, 3],
        subconCodes,
        purchaseUnitId: _this.purchaseUnitId
      };
      console.log(params, "黑名单校验数据");
      if (ids.length > 0) {
        checkSubconControlAndBlack(params).then(res => {
          if (res.data.code === "0") {
            let errmsg = "";
            // if (res.data.data.isTwoAndCliqueBlack === "1") {
            //   errmsg += res.data.data.twoAndCliqueErrBlackMsg;
            // }
            // if (res.data.data.isBlack === "1") {
            //   errmsg += res.data.data.blackErrMsg;
            // }
            // if (res.data.data.controlStatus !== "0") {
            //   errmsg += res.data.data.controlErrMsg;
            // }
            if (res.data.data.twoAndCliqueErrBlackMsg) {
              errmsg += res.data.data.twoAndCliqueErrBlackMsg;
            }
            if (res.data.data.blackErrMsg) {
              errmsg += res.data.data.blackErrMsg;
            }
            if (res.data.data.controlErrMsg) {
              errmsg += res.data.data.controlErrMsg;
            }
            if (errmsg) {
              this.$confirm(
                errmsg,
                "该分包商疑似被其他单位列入黑名单或者管控名单,是否继续提交？",
                {
                  dangerouslyUseHTMLString: true,
                  distinguishCancelAndClose: true,
                  confirmButtonText: "确认",
                  cancelButtonText: "取消",
                  customClass: "myDig"
                }
              ).then(() => {
                _this.dealSupComCheckEffect();
              });
            } else {
              _this.dealSupComCheckEffect();
            }
          }
        });
      } else {
        // 直接生效
        scpDealSupComCheckEffectApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          purStep: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          flag: 1
        }).then(res => {
          if (res.data.code == "0") {
            _this.$message({
              message: "详细评审生效成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            if (res.data.data.isEnd === true) {
              //y已结束，关闭评标室
              setTimeout(() => {
                window.parent.postMessage(false, "*");
              }, 500);
            } else {
              _this.init();
            }
          }
        });
      }
    },
    dealSupComCheckEffect() {
      // 提示“还有专家未提交确认结果，是否进行生效”
      let flag = true;
      if (this.billStatus == 0) {
        this.$confirm("还未提交确认，是否生效?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // 校验
            scpDealSupComCheckEffectApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              purStep: this.$router.history.current.query.menuKey,
              evaPurStep: this.$router.history.current.query.evaPurStep,
              flag: 0
            }).then(res => {
              if (res.data.code == "0" && res.data.data.isPass) {
                scpDealSupComCheckEffectApi({
                  schemeId: JSON.parse(
                    sessionStorage.getItem("expertSourceData")
                  ).schemeId,
                  pupurStep: this.$router.history.current.query.menuKey,
                  evaPurStep: this.$router.history.current.query.evaPurStep,
                  flag: 1
                }).then(res => {
                  if (res.data.code == "0") {
                    this.$message({
                      message: "详细评审生效成功！",
                      type: "success",
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });
                    if (res.data.data.isEnd === true) {
                      //y已结束，关闭评标室
                      setTimeout(() => {
                        window.parent.postMessage(false, "*");
                      }, 500);
                    } else {
                      this.init();
                    }
                  }
                });
              } else {
                this.$confirm(res.data.data.msg, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消"
                })
                  .then(() => {
                    scpDealSupComCheckEffectApi({
                      schemeId: JSON.parse(
                        sessionStorage.getItem("expertSourceData")
                      ).schemeId,
                      purStep: this.$router.history.current.query.menuKey,
                      evaPurStep: this.$router.history.current.query.evaPurStep,
                      flag: 1
                    }).then(res => {
                      if (res.data.code == "0") {
                        this.$message({
                          message: "详细评审生效成功！",
                          type: "success",
                          duration: 3000,
                          showClose: true,
                          ccuiCustom: true
                        });
                        if (res.data.data.isEnd === true) {
                          //y已结束，关闭评标室
                          setTimeout(() => {
                            window.parent.postMessage(false, "*");
                          }, 500);
                        } else {
                          this.init();
                        }
                      }
                    });
                  })
                  .catch(() => {});
              }
            });
          })
          .catch(() => {
            // flag = false;
            // return;
          });
      }
      console.log("this.billStatus", this.billStatus);
      if (this.billStatus == 0) {
        return;
      }
      let confirmUserNameList = [];
      let confirmUserNameListOk = [];
      try {
        console.log("this.expertConfirmtableData", this.expertConfirmtableData);
        this.expertConfirmtableData.forEach(item => {});
        const maxRound = Math.max(
          ...this.expertConfirmtableData.map(obj => obj.round)
        );

        confirmUserNameList = this.expertConfirmtableData.filter(
          obj => obj.round === maxRound
        );
        confirmUserNameList.forEach(item => {
          if (item.confirmStatus === "0") {
            flag = false;
            confirmUserNameListOk.push(item.confirmUserName);
            //  throw Error();
          }
        });
      } catch (e) {
        console.log(e);
      }
      if (flag && this.billStatus != 0) {
        scpDealSupComCheckEffectApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          purStep: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          flag: 0
        }).then(res => {
          if (res.data.code == "0" && res.data.data.isPass) {
            scpDealSupComCheckEffectApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              purStep: this.$router.history.current.query.menuKey,
              evaPurStep: this.$router.history.current.query.evaPurStep,
              flag: 1
            }).then(res => {
              if (res.data.code == "0") {
                this.$message({
                  message: "详细评审生效成功！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                if (res.data.data.isEnd === true) {
                  //y已结束，关闭评标室
                  setTimeout(() => {
                    window.parent.postMessage(false, "*");
                  }, 500);
                } else {
                  this.init();
                }
              }
            });
          } else {
            this.$confirm(res.data.data.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消"
            })
              .then(() => {
                scpDealSupComCheckEffectApi({
                  schemeId: JSON.parse(
                    sessionStorage.getItem("expertSourceData")
                  ).schemeId,
                  purStep: this.$router.history.current.query.menuKey,
                  evaPurStep: this.$router.history.current.query.evaPurStep,
                  flag: 1
                }).then(res => {
                  if (res.data.code == "0") {
                    this.$message({
                      message: "详细评审生效成功！",
                      type: "success",
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });
                    if (res.data.data.isEnd === true) {
                      //y已结束，关闭评标室
                      setTimeout(() => {
                        window.parent.postMessage(false, "*");
                      }, 500);
                    } else {
                      this.init();
                    }
                  }
                });
              })
              .catch(() => {});
          }
        });
      } else {
        console.log("confirmUserNameListOk", confirmUserNameListOk);
        console.log("confirmUserNameList", confirmUserNameList);
        /*  let arr = [];
        confirmUserNameList.forEach(item => {
          if (!confirmUserNameListOk.includes(item)) {
            arr.push(item);
          }
        }); */
        // confirmUserNameList = [...new Set(arr)];
        this.$confirm(
          `专家${confirmUserNameListOk.join("、")}还未确认，是否进行生效？`,
          "详细评审生效",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "ccui-message-box-custom"
          }
        )
          .then(res => {
            /*  let a = true;
            if (a) {
              return;
            } */
            scpDealSupComCheckEffectApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              purStep: this.$router.history.current.query.menuKey,
              evaPurStep: this.$router.history.current.query.evaPurStep,
              flag: 0
            }).then(res => {
              if (res.data.code == "0" && res.data.data.isPass) {
                scpDealSupComCheckEffectApi({
                  schemeId: JSON.parse(
                    sessionStorage.getItem("expertSourceData")
                  ).schemeId,
                  purStep: this.$router.history.current.query.menuKey,
                  evaPurStep: this.$router.history.current.query.evaPurStep,
                  flag: 1
                }).then(res => {
                  if (res.data.code == "0") {
                    this.$message({
                      message: "详细评审生效成功！",
                      type: "success",
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });
                    if (res.data.data.isEnd === true) {
                      //y已结束，关闭评标室
                      setTimeout(() => {
                        window.parent.postMessage(false, "*");
                      }, 500);
                    } else {
                      this.init();
                    }
                  }
                });
              } else {
                this.$confirm(res.data.data.msg, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消"
                })
                  .then(() => {
                    scpDealSupComCheckEffectApi({
                      schemeId: JSON.parse(
                        sessionStorage.getItem("expertSourceData")
                      ).schemeId,
                      purStep: this.$router.history.current.query.menuKey,
                      evaPurStep: this.$router.history.current.query.evaPurStep,
                      flag: 1
                    }).then(res => {
                      if (res.data.code == "0") {
                        this.$message({
                          message: "详细评审生效成功！",
                          type: "success",
                          duration: 3000,
                          showClose: true,
                          ccuiCustom: true
                        });
                        if (res.data.data.isEnd === true) {
                          //y已结束，关闭评标室
                          setTimeout(() => {
                            window.parent.postMessage(false, "*");
                          }, 500);
                        } else {
                          this.init();
                        }
                      }
                    });
                  })
                  .catch(() => {});
              }
            });
          })
          .catch(() => {});
      }
    },
    // 导出开始
    exportPdf() {
      this.exportData = [];
      if (this.tableData > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.exportExcelData.forEach((item, index) => {
          item.sscSupComPriceBOS.forEach((aItem, aIndex) => {
            this.exportData.push({
              id: index + 1,
              packName: item.packName,
              supName: aItem.supName,
              // priceAmount: aItem.priceAmount,
              passFlagStr: aItem.passFlagStr,
              reason: aItem.reason
            });
          });
        });
        if (this.ExcelJS) {
          this.exportDefaultAll();
        } else {
          this.exportCompatibleAll();
        }
      }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("分包商详细评审结果");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["分包商详细评审结果"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "包件名称",
        "分包商",
        // "税额",
        // "不含税金额",
        // "含税金额",
        "是否通过",
        "详细评审意见"
      ]);
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "packName", width: 25 },
        { key: "supName", width: 25 },
        // { key: "taxAmountCount", width: 25 },
        // { key: "noTaxPriceAmount", width: 25 },
        // { key: "priceAmount", width: 25 },
        { key: "passFlagStr", width: 50 },
        { key: "reason", width: 50 }
      ];
      let spanList = [];
      let start = 4;
      this.exportExcelData.forEach((item, index) => {
        let devspan = 0;
        devspan += item.sscSupComPriceBOS.length;
        item.sscSupComPriceBOS.forEach((aItem, aIndex) => {
          ws1.addRow([
            index + 1,
            item.packName,
            aItem.supName,
            // aItem.priceAmount,
            aItem.passFlagStr,
            aItem.reason
          ]);
        });
        spanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      spanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        ws1.mergeCells("B" + item.start + ":B" + item.end);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "分包商详细评审结果.xlsx");
    },
    exportCompatibleAll() {
      const header = [
        "序号",
        "包件名称",
        "分包商",
        // "税额",
        // "不含税金额",
        // "含税金额",
        "是否通过",
        "详细评审意见"
      ];
      const filterVal = [
        "id",
        "packName",
        "supName",
        // "taxAmountCount",
        // "noTaxPriceAmount",
        // "priceAmount",
        "passFlagStr",
        "reason"
      ];
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "分包商详细评审结果"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
.irem {
  display: flex;
  font-size: 14px;
  margin-bottom: 20px;
  justify-content: flex-start;
  .irems {
    width: 500px;
    display: flex;
    padding-right: 30px;
    justify-content: flex-start;
    .itt {
      flex: 1;
    }
  }
}
</style>
